export const PRODUCTS = {
  CAR: 'car',
  HOME: 'home',
};
